var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("entity-reader", {
    attrs: {
      entity: "ritual",
      id: _vm.id,
      "api-name": "ritualCircles",
      "edit-route-name": "editRitualCircle",
      "use-sharing": false
    },
    scopedSlots: _vm._u(
      [
        {
          key: `reader`,
          fn: function({ doc }) {
            return [
              _c("label-value", { attrs: { name: "Name", value: doc.name } }),
              _c("label-value", {
                attrs: { name: "Size", value: doc.sizeName }
              }),
              _c("label-value", {
                attrs: { name: "Active", value: doc.active }
              }),
              _c("label-value", {
                attrs: { name: "Location", value: doc.location }
              }),
              _c("label-value", {
                attrs: { name: "Bounce Location", value: doc.bounceLocation }
              }),
              _c("label-value", {
                attrs: { name: "Description", value: doc.description }
              }),
              _c("label-value", { attrs: { name: "Notes", value: doc.notes } }),
              _c("label-value", {
                attrs: { name: "Is Hidden", value: doc.isHidden }
              }),
              _c("label-value", {
                attrs: { name: "Flavour", value: doc.flavour }
              })
            ]
          }
        }
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }